function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "0.357,83.021 4.958,85.323 5.479,98.403 15.038,109.899 17.507,109.553 30.6,124.405  33.068,119.627 38.55,121.39 46.334,112.559 46.86,107.248 54.291,111.671 55.172,122.286 51.465,125.819 56.06,135.018  55.172,150.038 48.452,163.305 55.172,165.78 56.408,168.96 68.962,169.854 89.829,183.462 91.603,178.154 98.679,174.629  105.036,175.504 117.597,184.35 126.793,186.111 130.5,179.922 140.59,186.111 147.301,186.651 148.016,180.453 152.607,174.629  158.09,174.629 162.335,187.531 168.164,197.604 169.402,191.775 174.354,191.42 177.357,194.955 190.272,197.604 192.747,194.955  192.392,186.999 197.352,184.874 197.879,182.224 193.632,176.035 200,168.08 199.114,156.584 189.91,154.465 195.396,148.63  198.584,142.084 193.281,136.786 196.641,131.121 178.598,131.121 170.997,132.885 151.901,129.348 147.301,117.33 138.105,112.907  138.815,118.214 113.701,108.131 113.701,99.821 117.068,98.937 117.943,92.746 113.352,85.68 109.636,86.561 107.513,81.782  99.209,81.255 98.679,84.444 90.363,83.911 88.595,80.376 89.481,70.291 89.121,52.254 82.055,35.461 82.402,19.184 72.862,3.274  71.441,2.396 71.441,5.035 73.563,6.811 64.895,13.361 61.535,24.495 55.172,23.963 53.934,26.623 56.06,38.114 45.982,48.189  31.832,66.765 13.441,72.057 0,80.9 "
});

var Svg24 = function Svg24(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SLP",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg24, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/24.37dd62cf.svg";
export { ForwardRef as ReactComponent };